<template>
  <div class="sticky-nav">
    <nav class="px-3 py-2">
      <div class="d-flex justify-content-between">
        <div
          class="d-block align-self-center cursor-pointer"
          style="height: 30px"
        >
        <carbonwize-logo :isExpanded="true" />
          <!-- <img
            src="@/assets/logo-landing-black.svg"
            @click="gotoMain"
            height="100%"
          /> -->
        </div>
        <div v-if="$route?.name != 'WasteMeasurementDetail'" class="d-flex justify-content-end align-self-center h-100">
          <button
            :class="{ opened: opened }"
            class="menu"
            aria-label="Main Menu"
            v-if="
              $route.path !== '/' &&
              $route.path !== '/book-demo' &&
              $route.path !== '/thankyou' &&
              $route.path !== '/register-code' &&
              $route.path !== '/register' &&
              $route.path !== '/verify'
            "
            @click="opened = !opened"
          >
            <img src="@/assets/mobile/nav/menu-icon.svg" alt="" />
          </button>
        </div>
      </div>
    </nav>

    <div class="menu-mobile" :class="{ opened: opened }">
      <div class="container h-100 position-relative">
        <div class="burger d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center gap-4">
            <img
              alt=""
              v-if="$store.state.company_data?.[0]?.file?.file_url"
            
              :src="$store.state.company_data?.[0]?.file?.file_url"
              style="max-width: 70px; max-height: 60px"
              @click="gotoMain"
            />
            <img
              v-else
              alt=""
              src="@/assets/logonav.png"
              style="width: 60px; height: 60px"
              @click="gotoMain"
            />
            <h1
              style="font-size: 1.4rem; text-align: initial"
              v-if="$store.state"
              @click="gotoMain"
            >
              {{ $store.state.company_data?.[0]?.name_en }}
            </h1>

          </div>
          <div>
            <button
              :class="{ opened: opened }"
              class="menu"
              aria-label="Main Menu"
              @click="opened = !opened"
            >
              <svg
                width="50"
                height="50"
                viewBox="-20 -20 100 100"
                style="background-color: white"
              >
                <path
                  d="M18.75 36.0004L16.6 33.8504L26.5 23.9504L16.6 14.0504L18.75 11.9004L30.8 23.9504L18.75 36.0004Z"
                  fill="black"
                />
              </svg>
            </button>
          </div>
        </div>

        <!-- <div class="col-1 d-flex align-items-center">
              <button
                :class="{ opened: opened }"
                class="menu"
                aria-label="Main Menu"
                @click="opened = !opened"
              >
              <svg
                  width="30"
                  height="30"
                  viewBox="0 5 50 50"
                  style="background-color: white"
                >
                  <path
                    d="M18.75 36.0004L16.6 33.8504L26.5 23.9504L16.6 14.0504L18.75 11.9004L30.8 23.9504L18.75 36.0004Z"
                    fill="black"
                  />
                </svg>
              </button>
            </div> -->

        <div>
          <ul>
            <li class="menu-list p-2">
              <div class="d-flex gap-4 px-4" @click="gotoFill">
                <div class="flex-middle">
                  <img alt="" src="@/assets/mobile/nav/menu1.png" />
                </div>
                <div>
                  <span>กรอกข้อมูลรายวัน</span>
                </div>
              </div>
            </li>
            <li class="menu-list p-2" disabled>
              <div class="d-flex px-4 gap-4">
                <div class="flex-middle">
                  <img alt="" src="@/assets/mobile/nav/menu3.png" />
                </div>
                <div>
                  <span>กรอกข้อมูลรายเดือน แนบใบเสร็จ</span>
                </div>
              </div>
            </li>
            <li class="menu-list p-2" disabled>
              <div class="d-flex px-4 gap-4">
                <div class="flex-middle">
                  <img alt="" src="@/assets/mobile/nav/menu4.png" />
                </div>
                <div>
                  <span>ดูกราฟรายเดือน ตามใบเสร็จ</span>
                </div>
              </div>
            </li>
            <li class="menu-list p-2">
              <div class="d-flex px-4 gap-4" @click="logout">
                <div class="flex-middle">
                  <img
                    alt=""
                    src="@/assets/mobile/nav/menu5.png"
                    width="24"
                    height="24"
                  />
                </div>
                <div>
                  <span href="https://8z9zefp80qj.typeform.com/to/qyQUB5Px">
                    ออกจากระบบ
                  </span>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div class="position-absolute bottom-0 w-100">
          <div
            class="profile-section d-flex align-items-center justify-content-between"
            @click="editProfile"
          >
            <div class="d-flex align-items-center gap-4">
              <img alt="" src="@/assets/mobile/nav/profile.png" />
              <h1
                v-if="
                  profile && profile.first_name && profile.first_name.length > 0
                "
                style="font-size: 24px; text-align: initial"
              >
                {{ profile ? profile.first_name : "" }}
                {{ profile ? profile.last_name : "" }}
              </h1>
              <h1 v-else style="font-size: 18px; text-align: initial">
                {{ profile ? profile.email : "" }}
              </h1>
              <h2 style="font-size: 16px; text-align: initial">
                {{ profile ? profile.job_role : "" }}
              </h2>
            </div>
            <div>
              <button class="menu" aria-label="Main Menu">
                <svg
                  width="50"
                  height="50"
                  viewBox="-20 -20 100 100"
                  style="background-color: white"
                >
                  <path
                    d="M18.75 36.0004L16.6 33.8504L26.5 23.9504L16.6 14.0504L18.75 11.9004L30.8 23.9504L18.75 36.0004Z"
                    fill="black"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { httpClient } from "@/token/axios.js";
import { mapGetters } from "vuex";
import { apiURL } from "@/configs/serverConfig";
import store from "@/store";
import CarbonwizeLogo from "@/assets/logo/CarbonwizeLogo.vue";

export default {
  components : {
    CarbonwizeLogo
  },
  data() {
    return {
      opened: false,
      profile: null,
    };
  },
  methods: {
    editProfile() {
      this.$router.push("/profile").catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    },
    gotoMain() {
      if (store.state.token.length) {
        this.$router.push("/main").catch((error) => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
      }
    },
    gotoDetail() {
      this.$router.push("/daily-chart");
    },
    gotoFill() {
      this.$router.push("/buildings").catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    },
    logout() {
      this.$store.commit("setToken", "");
      this.$store.commit("setRoleAction", null);
      this.$router.go();
    },
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters(["getToken"]),
  },
  mounted() {
    if (this.$store.state.token !== "" && this.$store.state.access_from != 'measure_qr_code') {
      httpClient
        .get(`${apiURL}/user`, {
          headers: {
            Accept: "application/json",
            "Content-type": "application/json",
            Authorization: `Bearer ${this.$store.state.token}`,
          },
        })
        .then((response) => {
          this.profile = response.data;
        });
    }
  },
};
</script>

<style lang="scss">
.sticky-nav {
  position: sticky; /* ทำให้ sticky */
  top: 0; /* ติดด้านบนสุด */
  z-index: 1000; /* ให้ลอยอยู่เหนือองค์ประกอบอื่น */
  background-color: white; /* พื้นหลังเพื่อให้เนื้อหาไม่ทับ */
}

.menu-mobile {
  overflow: hidden;
  height: 0;
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  top: 0;
  background-color: #fff;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;

  &.opened {
    height: 100vh;
    bottom: 0;
  }

  .burger {
    height: 80px;
  }

  .menu-list {
    cursor: pointer;
  }

  .menu-list[disabled] {
    cursor: default; /* ไม่มีการเปลี่ยน cursor */
    pointer-events: none; /* ปิดการโต้ตอบ */
    opacity: 0.6; /* ทำให้ดูจางลง */
  }


  ul {
    padding: 0;
    margin-bottom: 0;

    li {
      list-style-type: none;
      width: 100%;
      text-align: start;

      font-size: 16px;

      a {
        color: #51646b;
        padding: 13px 0;
        display: block;
      }

      span {
        color: #1d273f;
        padding: 13px 0;
        display: block;
        font-family: "Kanit", Roboto, sans-serif;
        // font-family: 'Roboto';
      }
    }
  }

  .contact-us {
    position: absolute;
    bottom: 5%;
    left: 15px;
    right: 15px;
  }
}

h1 {
  font-family: "Kanit", Roboto, sans-serif;
  // font-family: 'Roboto';
}

h2 {
  font-family: "Kanit", Roboto, sans-serif;
  // font-family: 'Roboto';
}

.menu {
  background-color: white;
  border: none;
  cursor: pointer;
  display: flex;
  padding: 0;

  &.opened {
    // position: fixed;
  }
}

.flex-middle {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.profile-section {
  height: 80px;
  width: 95%;
  // justify-content: flex-end;
  align-items: center;
  /* padding-bottom: 10rem; */

  cursor: pointer;
}

.nav-text {
  font-size: 16px;
  font-family: "Kanit", Roboto, sans-serif;
  // font-family: "Roboto";
  color: white;
}

.line {
  fill: none;
  stroke: white;
  stroke-width: 6;
  transition: stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),
    stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1);
}

.line1 {
  stroke-dasharray: 60 207;
  stroke-width: 6;
}

.line2 {
  stroke-dasharray: 60 60;
  stroke-width: 6;
}

.line3 {
  stroke-dasharray: 60 207;
  stroke-width: 6;
}

.opened {
  .line {
    fill: none;
    stroke: black;
    stroke-width: 6;
    transition: stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),
      stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  .line1 {
    stroke-dasharray: 90 207;
    stroke-dashoffset: -134;
    stroke-width: 6;
  }

  .line2 {
    stroke-dasharray: 1 60;
    stroke-dashoffset: -30;
    stroke-width: 6;
  }

  .line3 {
    stroke-dasharray: 90 207;
    stroke-dashoffset: -134;
    stroke-width: 6;
  }
}

.menu:focus {
  outline: 0px;
}

@media only screen and (min-width: 415px) and (max-width: 912px) {
  .menu-mobile {
    .contact-us {
      left: 20%;
      right: 20%;
      margin-top: 100px;
      bottom: unset;
    }
  }
}
</style>
